import Vue from 'vue'

//过滤器
//格式化日期添加完整格式小于10的加0
//年月日
Vue.filter('timeFormat', function (value) {
    let month = value.getMonth()+1
    let day = value.getDate()
    if(month < 10){
      month = '0' + month
    }else{
      month = month
    }
    if(day < 10){
      day = '0' + day
    }
    let date = value.getFullYear() + '/' + month + '/' + day
    return date
  })
  //年月
  Vue.filter('timeMonth', function (value) {
    let month = value.getMonth()+1
    if(month < 10){
      month = '0' + month
    }else{
      month = month
    }
    let date = value.getFullYear() + '/' + month
    return date
  })
  //年
  Vue.filter('timeYear', function (value) {
    let date = value.getFullYear()
    return date
  })


// WEBPACK FOOTER //
// ./src/common/filter/index.js